gx-query-viewer-pivot-render {
  display: contents;
}
